module.exports = __webpack_public_path__ + "static/media/tilda_2.a9415326.jpg";